module.exports = __webpack_public_path__ + "static/media/teacher16.e9f1be49.png";